var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-content",class:{ 'collapsed': _vm.collapse }},[(_vm.icon)?_c('i',{class:['menu-icon', _vm.icon]}):_vm._e(),(!_vm.collapse)?_c('span',{staticClass:"menu-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }